export default __webpack_public_path__ + "static/media/case-banner1.946e0693.png";